import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import {FormHelperText, Grid, Typography} from '@material-ui/core';
import fields from 'components/forms/cg719s/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {AbortButton} from 'components/forms/sections/RequiresSignatureAbortButton';
import {requiresSignedPaperworkText} from 'components/forms/sections/RequiresSignatureAbortButton';

const Signature = props => {
    const {schema, initialValues} = bootstrapOldForm('Signature', fields);
    const [signed, setSigned] = useFieldData('document_signed');
    const [userSigned, setUserSigned] = useFieldData('document_signed_user');
    const [ssnIncluded, setSSNIncluded] = useFieldData('ssn_included');

    const showSignedWarning =
        signed === false ||
        signed === 'false' ||
        userSigned === false ||
        userSigned === 'false';

    const showNumberIncludedWarning =
        ssnIncluded === false || ssnIncluded === 'false';

    const updateUserSigned = event => {
        setUserSigned(event.target.value === 'true');
    };
    const updateSigned = event => {
        setSigned(event.target.value === 'true');
    };
    const updateSSNIncluded = event => {
        setSSNIncluded(event.target.value === 'true');
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Signature
            </Typography>
            <Typography variant='body1' align='left'>
                Let's get started! First, we will check that both parts of Section III: Signature and Verification are complete. It's typically on the second page of your Small
                Vessel Sea Service form. You need to make sure you have both signature fields complete.
            </Typography>
            <AutoField
                field={fields.document_signed_user}
                name='document_signed_user'
                onChange={updateUserSigned}
            />
            <AutoField
                field={fields.document_signed}
                name='document_signed'
                onChange={updateSigned}
            />
            {(signed === true || signed === 'true') && (
                <AutoField
                    field={fields.date_document_signed}
                    name='date_document_signed'
                />
            )}
            <Typography variant='body1'>
                If you don't have a USCG MMC Reference Number, make sure you
                include your Social Security Number on your form (last four
                digits is OK)
            </Typography>
            <AutoField
                field={fields.ssn_included}
                name='ssn_included'
                onChange={updateSSNIncluded}
            />
            {(showSignedWarning || showNumberIncludedWarning) && (
                <Grid container spacing={2}>
                    {showSignedWarning ? (
                        <Grid item xs={12}>
                            <FormHelperText error>
                                {requiresSignedPaperworkText}
                            </FormHelperText>
                        </Grid>
                    ) : null}
                    {showNumberIncludedWarning ? (
                        <Grid item xs={12}>
                            <FormHelperText error>
                                This form requires either an included Reference
                                Number or the last 4 digits of your Social
                                Security Number. Please add either of these to
                                the form and upload again.
                            </FormHelperText>
                        </Grid>
                    ) : null}
                    <Grid item xs={12}>
                        <AbortButton />
                    </Grid>
                </Grid>
            )}
            {props.children}
        </Section>
    );
};

export default Signature;
